// this file added for individual by Bearer Web Developer
import React from "react";
import { Observer } from "mobx-react-lite";
import styles from './mobileForm.module.scss';
import BearerTextField from "../../../components/fields/BearerTextField";
import { useAppState } from "../../../states/app-state";
import { validatePhone } from "./validate";
import { toJS } from "mobx"; // added by Bearer Web Developer (for getting data object of states)
import { Button } from "@mui/material";
import { SigninSituation } from "../../../states/signinState";

interface Props {
    sign: 'signin' | 'signup'
}

const MobileForm: React.FC<Props> = ({ sign }) => {

    const appState = useAppState();
    const { login, signin } = appState;
    const [error, setError] = React.useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const valid = !!login.mobileNumber && !validatePhone(login.mobileNumber);
        console.log({ login: toJS(login) });
        if (valid) {
            try {
                if (error) setError('');
                signin.setLoading(true);
                const result = await appState.signin.loginWithPhoneNumberconfirmation(`+61${login.mobileNumber}`);
                signin.setLoading(false);
                if (result) {
                    // Enter Code For Signin or Signup
                    const newSituation = sign === 'signin' ? SigninSituation.EnterCodeForSignin :
                        SigninSituation.EnterCodeForSignup;
                    signin?.setSituation(newSituation);
                    console.log(result);
                }
            } catch (err: any) {
                signin.setLoading(false);
                // console.log({LoginPopupError: err?.message}) // added by Bearer Web Developer
                // the setError modified by Bearer Web Developer start
                if (err?.message === "Firebase: Error (auth/too-many-requests).") {
                    setError("Too many requests");
                } else if (err?.message === "Firebase: Error (auth/network-request-failed).") {
                    setError("Network error. Please check your connection and try again.");
                } else if (err?.message === "Firebase: Error (auth/missing-phone-number).") {
                    setError("Please enter your phone number.");
                } else if (err?.message === "Firebase: Error (auth/invalid-phone-number).") {
                    setError("The phone number format is invalid. Please check and try again.");
                } else if (err?.message) {
                    setError(err?.message);
                }
                console.log(err?.message);
                console.log(err);
                // the setError modified by Bearer Web Developer end
            }
        }
    }
    return (
        <form className={styles.form} onSubmit={handleSubmit}>
            <Observer>{() => (
                <div className={styles.mobile_input}>
                    <div className={styles.prefix_input}>
                        <input
                            type="text"
                            maxLength={3}
                            placeholder=""
                            value='+61'
                            disabled={true}
                        />
                    </div>
                    <BearerTextField
                        colorStyle="white"
                        inputProps={{ maxLength: "9" }} // add maxlength of Phone Number of destination by Bearer Web Developer
                        placeholder={"e.g. 400 000 000"}
                        value={login.mobileNumber}
                        type="tel"
                        inputMode="numeric"
                        onChange={(e) => {
                            if (error) setError('');
                            const value = e.target.value.replace(/\D+/g, '');
                            const text =
                                (value.startsWith('0') && value.length > 1 && (value?.slice(1, 2) !== '0')) ?
                                    value.slice(1) : value;
                            login.setMobileNumber(text);
                        }}
                        clear={() => { login.setMobileNumber('') }} // added by Bearer Web Developer
                        validator={validatePhone}
                    />
                </div>
            )}</Observer>
            {/* FormControl removed by Bearer Web Developer */}
            {/* password input added and later removed for individual by Bearer Web Developer */}
            {error && <div className={styles.error}>{error}</div>}  {/* added by Bearer Web Developer */}
            <Observer>{() => {
                const valid = !!login.mobileNumber && !validatePhone(login.mobileNumber);
                return (
                    <>
                        <Button
                            type='submit'
                            className={styles.verify}
                            variant="text"
                            color="primary"
                            fullWidth
                            disabled={!valid}
                            disableRipple={true}
                        >
                            Verify
                        </Button>
                    </>
                )
            }}</Observer>
            {/*removed text and link by Bearer Web Developer */}
        </form>
    )
}
export default MobileForm;